
import React,{ Component, Fragment } from "react";
import { connect } from 'react-redux';
import { socketConnect } from 'socket.io-react';
import { getArrays } from 'lib';
import PropTypes from 'prop-types';
import Tabs from '../../components/Checkout/Tabs';
import CustomFitTabs from '../../components/Checkout/Customfit/Tabs';
import { spin, stop } from '../../store/spinner'; 
import Notpaidnotification from '../../components/Checkout/Notpaidnotification';
import RadioInputNew from '../../components/RadioInput/indexnew';
import Price from '../../components/Checkout/Price';
import RightArrow from 'assets/btn-right-arrow-new.png';
import { setCheckoutPlanParams,updateCheckoutPlanParams } from '../../store/checkoutPlanParams';
import { setCheckoutMealPlan,updateCheckoutMealPlan } from '../../store/checkoutMealPlan';
import { browserHistory, Link } from "react-router";
import InputValidation from 'components/InputValidation';
class CheckoutSummary extends Component{

    constructor(props) {
        super(props);
        const { checkoutPlanParams, checkoutMealPlan } = this.props;
        const { id:checkoutId } = checkoutPlanParams;
        if(Object.keys(checkoutMealPlan).length<=0 || checkoutPlanParams==undefined) browserHistory.push('/checkout');
        const today = moment().startOf('day');
        const startDate = (checkoutMealPlan)?Object.keys(checkoutMealPlan)[0]:'';
        const date = moment.unix(startDate); 
        const buffered = today.unix()> startDate || date.isBetween(today, today.clone().add(3, 'day'), '[)');
        if(buffered) browserHistory.push('/checkout/delivery-dates');

        let bgPrice=(checkoutPlanParams.bag_price!=undefined)?(checkoutPlanParams.bag_price || 180):180;
        let couponCode=(checkoutPlanParams.priceDatas!=undefined)?(checkoutPlanParams.priceDatas.couponCode || ''):'';
        this.state={
            cutlery:checkoutPlanParams.cutlery || 0,
            bag_price:bgPrice,
            paymentMethod:'paymennt',
            couponCode,
            couponError:[],
            customfitConfig:{}
        }
    }
    renderContent = (title,content) =>{
        return <div className="summary-label-con">
        <p className='summary-label'>{title}</p>
        <h6>{content}</h6>
     </div>
      }
    componentDidMount(){
     
      const { socket } = this.props;
      if(socket.connected){
          this.initializeData();
      }else{
          socket.on('connect', (data) => {
              this.initializeData();
          });
      } 
    }
    validateMealPlan = () =>{
      const { checkoutMealPlan,checkoutPlanParams } = this.props;
      if(Object.keys(checkoutMealPlan).length<=0 || checkoutPlanParams==undefined) {browserHistory.push('/checkout'); return false;};
      return true;
    }
    initializeData =() =>{
      const { socket, dataArray,user,checkoutMealPlan,checkoutPlanParams } = this.props;
      // console.log(dataArray);
      this.getCustomFitSettings();
      const types = ['dietList','typeList','productsList','priceList'].filter(el => !(el in dataArray));
      types.length && getArrays(socket, types);
      if(!user.token){
        if(Object.keys(checkoutMealPlan).length<=0 || checkoutPlanParams==undefined) browserHistory.push('/checkout');
      }else{
        const { id:checkoutId } = this.props.checkoutPlanParams || {};
        this.getPending(user.user_id);
        if(checkoutId){
          this.addDataLayer();
        }
      }
    
    }
    getCustomFitSettings= () =>{
      this.props.socket.emit('settings', { type: 'getCustomfit', data: {} });
    }
    calcPrice = (types) => {
      let pricetype=1;
      const {  dataArray,checkoutPlanParams } = this.props;
      const { diet_id: diet, days_count:dayCount, mealPlan_id:mealplanId} = checkoutPlanParams;
      const { priceList } = dataArray;
      types=types.map(Number);
      if (priceList && diet && mealplanId && types ) {
        const dayPrice = priceList
          .filter(el => +el.diet_id === +diet && +el.mealPlan_id === +mealplanId && types.includes(+el.mealType_id))
          .reduce((acc, cur) =>{ if(pricetype){ return acc + +cur.newValue }else{ return acc + +cur.value } }, 0);
        return dayPrice * +dayCount;
      } else{
        return 0;
      }
    }

    componentWillMount() {
      this.props.socket.on('mobile_checkout', this.listener);
      this.props.socket.on('settings', this.listener);

    }
    componentWillUnmount() {
    this.props.socket.removeListener('mobile_checkout', this.listener);
    this.props.socket.removeListener('settings', this.listener);
  }
  
    listener = ({ type, data, message }) => {
      this.props.stop();
      // console.log(type);
      const { setCheckoutPlanParams, setCheckoutMealPlan } = this.props;
      switch (type) {
        case 'setOk':
          if(data.planParams!=undefined){
            setCheckoutPlanParams(data.planParams);
            setCheckoutMealPlan(data.mealPlan);
          }
        break;
        case 'updateOk':
            // console.log(data);
            // navigation.navigate('BuildMenuPayment');
            const { paymentMethod } = this.state;
            if(paymentMethod=='not_paid'){
              browserHistory.push('/checkout/success/paylater');
            }else if(paymentMethod=='paymennt'){
              this.createPaymenntWeb(data.checkoutId);
            }else{
              this.createTelrSession(data.checkoutId);
            }
          break;
          case 'applyCouponOk':
            const { updateCheckoutPlanParams } = this.props;
            const { error,message:msg, priceDatas } =data;
            if(error){
              let errorVal={};
              errorVal['couponCode']=msg;
              this.setState({couponCode:'',couponError:errorVal});
            }else{
              this.setState({couponError:[]});
            }
            updateCheckoutPlanParams({priceDatas:priceDatas});
          break;
          case 'getPendingOk':
              if(data && data.mealPlan !=undefined ){
                setCheckoutPlanParams(data.planParams);
                setCheckoutMealPlan(data.mealPlan);
                this.setState({cutlery:data.planParams.cutlery,bag_price:data.planParams.bag_price});
              }else{
                this.setPlan();
              }
            break;
            case 'getCustomfit':
             this.setState({customfitConfig:data});
            break;
        case 'createTelrSessionOk':
          console.log(data.response);
        //   const { setCheckoutPlanParams } = this.props;
        //   const { setCheckoutMealPlan } = this.props;
        //   if(data.planParams!=undefined){
        //     setCheckoutPlanParams(data.planParams);
        //     setCheckoutMealPlan(data.mealPlan);
        //   }
        if(data.response!=undefined){
            if(data.response.order!=undefined){
                // browserHistory.push(data.response.order.url);
                window.location.href =data.response.order.url;
                return null;
            }
            
        }
          
        break;
        case 'createPaymenntWebOk':
          console.log(data.response);
        //   const { setCheckoutPlanParams } = this.props;
        //   const { setCheckoutMealPlan } = this.props;
        //   if(data.planParams!=undefined){
        //     setCheckoutPlanParams(data.planParams);
        //     setCheckoutMealPlan(data.mealPlan);
        //   }
        if(data.response!=undefined){
            if(data.response!=undefined){
                // browserHistory.push(data.response.order.url);
                window.location.href =data.response.redirectUrl;
                return null;
            }
            
        }
          
        break;
        case 'setErr':
          // console.log(data);
          console.log(message);
        break;
      }
    }
     applyClick=()=>{
      this.props.spin();
      const { checkoutPlanParams } = this.props;
      const { couponCode } = this.state;

      this.props.socket.emit('mobile_checkout', { type: 'applyCoupon',   data: {
          couponCode:couponCode,
          userId:checkoutPlanParams.user_id,
          checkoutId:checkoutPlanParams.id
        }});
    }
    setPlan = () =>{
      const { checkoutPlanParams,user,checkoutMealPlan } =this.props;
      const { priceDatas } = checkoutPlanParams;
      const { slot_id, emirate_id } =this.state;
      // console.log('checkoutPlanParams');
      // console.log(checkoutPlanParams);
      // console.log(checkoutMealPlan);
      let checkDates = Object.keys(checkoutMealPlan);
      let checkOutdata ={...checkoutPlanParams,user_id:user.user_id,full_price:priceDatas.price,discount_price:priceDatas.savedAmount,start_date:checkDates[0],end_date:checkDates[(checkDates.length)-1]};
      // console.log(checkOutdata); 
      // console.log(checkoutMealPlan);
      this.props.socket.emit('mobile_checkout', { type: 'set',   data: {
        checkoutPlanParams:checkOutdata,
        detailsData: checkoutMealPlan
      }});
      // props.stop();
   }
    savePlan = (checkoutId) =>{
        
        const { updateCheckoutPlanParams,checkoutPlanParams,checkoutMealPlan, user } = this.props;
        if(user.token){
          const { cutlery,bag_price } = this.state;
          updateCheckoutPlanParams({cutlery:cutlery,bag_price:bag_price});
          let checkOutdata ={cutlery:cutlery,bag_price:bag_price};
          // console.log('checkOutdata');
          // console.log(bag_price);
          // console.log(checkOutdata);
          // console.log(checkoutPlanParams.days_count);
          // console.log(Object.keys(checkoutMealPlan).length);
          if(checkoutPlanParams.days_count==Object.keys(checkoutMealPlan).length){
              this.props.spin();
              this.props.socket.emit('mobile_checkout', { type: 'update',   data: {
                    details:checkOutdata,
                    checkoutId:checkoutId
                  }});
          }else{
            alert('Meal plan days and generate meals count are mismatched. Please check days count or Delete and Start Over meal plan.');
          }
        }else{
          browserHistory.push('/sign-in?redirect=checkout');
        }
       
     }
     getPending = user_id => this.props.socket.emit('mobile_checkout', { type: 'getPending', data: { user_id } });
    createTelrSession = (checkoutId) =>{
        this.props.spin();
        this.props.socket.emit('mobile_checkout', { type: 'createTelrSession', data: { checkoutId } });
    }
    createPaymenntWeb = (checkoutId)=>{
      this.props.spin();
      this.props.socket.emit('mobile_checkout', { type: 'createPaymenntWeb', data: { checkoutId } });
    }
    onChange = (name,val)=>{
        this.setState({[name]:val});
    }
    addDataLayer =() =>{
      const { dataArray, checkoutPlanParams } = this.props;
      const { dietList } = dataArray;
      const { days_count,priceDatas, diet_id } = checkoutPlanParams;
      console.log('Data Layer');
      if(window.dataLayer){
        const { discountPriceCoupon, discountPrice,price } = priceDatas;
        const fixedPrice = (discountPriceCoupon!=undefined && discountPriceCoupon>0)?discountPriceCoupon/100:((discountPrice!=undefined && discountPrice>0)?discountPrice/100:0);
        const totalPrice =((fixedPrice>0)?fixedPrice:price/100);
        const  dietTilte = dietList[diet_id] || null;
          dataLayer.push({
            'event': 'begin_checkout',
            'items': [{
            'item_name': dietTilte+' - '+days_count+' Days',  // Replace with the meal plan name
            'item_id': 'diet-'+diet_id+'-d-'+days_count,
            'price': totalPrice,
            'quantity': 1,
            'item_category': 'Meal Plans'
          }]
          });
        }
    }
    renderPriceData(bag_price){
      const { dataArray, checkoutPlanParams } = this.props;
      const { dietList } = dataArray;
      const { days_count,priceDatas, diet_id } = checkoutPlanParams;
      // const { discountPriceCoupon, discountPrice,price } = priceDatas;
      //   const fixedPrice = (discountPriceCoupon!=undefined && discountPriceCoupon>0)?discountPriceCoupon/100:((discountPrice!=undefined && discountPrice>0)?discountPrice/100:0);
      //   const totalPrice =((fixedPrice>0)?fixedPrice:price/100);
      //   const dietTilte= dietList[diet_id] || null;
      //   console.log({
      //     'event': 'begin_checkout',
      //     'items': [{
      //     'item_name': dietTilte+' - '+days_count+' Days',  // Replace with the meal plan name
      //     'item_id': 'diet-'+diet_id+'-d-'+days_count,
      //     'price': totalPrice,
      //     'quantity': 1,
      //     'item_category': 'Meal Plans'
      //   }]
      //   });
      return <Price priceDatas={priceDatas} isShowBag={bag_price>0} />;
    }
    displayPirce =(price)=>{
      return (Math.round((price/100) * 100) / 100) + ' AED';
    }
    calCustomfitPrice =(addMealTypes)=>{
      const { checkoutMealPlan } = this.props;
      let total =0;
      (addMealTypes.length>0)&&Object.keys(checkoutMealPlan).map((timestamp)=>{
        addMealTypes.map((val)=>{
          const innerObj = checkoutMealPlan[timestamp][val];
          // console.debug('innerObj');
          // console.debug(innerObj);
          for (const innerKey in innerObj) {
            const item = innerObj[innerKey];
            if(item.price!=undefined){
              const price1 = item.price * 100;
              total += price1;
            }
          }
        });
      }) 
      return total;
    }
    render(){
        const cutleryDatas =[{'title':'Yes',value:1},{'title':'No',value:0}];
        const paymentOption =[{'title':'Pay Later - Payment via online payment link to be sent later.',value:'not_paid'},
          {'title':'Payment via online',value:'paymennt'},];
        // const paymentOption =[{'title':'Payment via online',value:'paymennt'}];
        const bagPriceOption = [
            { title: '180 AED Refundable Bag Deposit', value: 180,message:''  },
            { title: 'Renewal: already paid bag deposit', value: 0,message:'*Bag Deposit is Mandatory. If not paid, it be charged before start of the plan.' }
          ];
        const { checkoutPlanParams,dataArray,user } = this.props;
        // if(!user.token){
          if(!this.validateMealPlan()){
            return false;
          }
        // }
        // console.log(checkoutPlanParams);
        const { typeList,dietList,priceList } = dataArray; 
        const { days_count,diet_id,mealTypes,priceDatas,id:checkoutId } = checkoutPlanParams;
        // console.debug('checkoutPlanParams');
        // console.debug(checkoutPlanParams);
        const { bag_price,cutlery,paymentMethod, couponCode,couponError,customfitConfig } = this.state;
        const { diet_id:customfitDietId,preset_mealtype_ids,main_mealtype_ids } = customfitConfig || {};
        const { couponCode:applyCoupon, discountPrice, discountPer, discountType,discountTypeCoupon:couponType,discountPriceCoupon:couponDiscount, discountPerCoupon:couponPerDiscount } = priceDatas;
        // console.log('couponError');
        // console.log(applyCoupon);
        let addMealTypes =[];
        let addAddonMealTypes =[]; 
        const mealTypeList = (mealTypes && typeList && main_mealtype_ids) ? mealTypes.filter(
          (meal) => main_mealtype_ids.includes(String(meal))
        ).map((val)=>{
          if(typeList[val].parent_id==0 || typeList[val].parent_id==null){
            addMealTypes.push(val);
            return typeList[val].title;
          }
          }).filter(n => n):[];
          const addOnList = (mealTypes && typeList  && customfitDietId==diet_id && preset_mealtype_ids) ? mealTypes.filter(
            (meal) => preset_mealtype_ids.includes(String(meal))
          ).map((val)=>{
            if(typeList[val].parent_id==0 || typeList[val].parent_id==null){
              addAddonMealTypes.push(val);
              return typeList[val].title;
            }
            }).filter(n => n):[];
        let addPrice = this.calcPrice(addAddonMealTypes);
        let mealPrice =(customfitDietId==diet_id)? this.calCustomfitPrice(addMealTypes):this.calcPrice(addMealTypes);
        let subTotal = mealPrice+addPrice;
        const fixedPrice = (couponPerDiscount!=undefined && couponPerDiscount>0)?couponDiscount:((discountPer!=undefined && discountPer>0)?discountPrice:0);
        const totalPrice =parseInt((discountPer>0||couponPerDiscount>0)?fixedPrice:subTotal)+parseInt(bag_price>0?bag_price*100:0);
     
        return <Fragment>
        <div className="main-holder checkout-process-con wrap-progress-page" >
        <Notpaidnotification />
        <div className="container checkout-process summary">
                    <div className="row">
                    <div className='col-12'>
                       {diet_id==customfitDietId?<CustomFitTabs checkoutId={checkoutId} />:<Tabs />}
                       <div class="step-form-group">
                       <h5>Checkout</h5> 
                       </div>
                       <div className="summary-container">
                        <div className="summary-con-left">
                          <div className="summary-head"><h2>Order Summary</h2>   {!user.token && <Link to='/sign-in?redirect=checkout' className='back-link'>Sign In</Link>}</div>
                           <div class="summary-label-head"><p class="summary-label">Plan & Days</p><h6>{(dietList?dietList[diet_id]:'')+' - '+days_count+" Days"}</h6><div></div></div>
                            {this.renderContent('Meals',mealTypeList.join(' , ')+" : "+(this.displayPirce(mealPrice)))}
                            {addOnList.length>0 ? this.renderContent('Preset Meals',addOnList.join(' , ')+' '+this.displayPirce(addPrice/days_count)+' x '+days_count+' Days ='+this.displayPirce(addPrice)):''}
                            {this.renderContent('Sub Total',this.displayPirce(subTotal))}
                           
                           
                       </div>
                       <div className="summary-con-right">
                            <div className="summary-con-right-sticky">
                            <div className="summary-con-right-container">
                            {/* <div className='coupon-code-con'>
                            <h2>Coupon Code or Voucher</h2>
                                <InputValidation
                                  name='couponCode'
                                  value={couponCode}
                                  onChange={this.onChange}
                                  placeholder='Enter voucher code'
                                  errors={couponError}
                                  inputSelfClassName='standart-input b-rounded-blue'
                                />
                                 <div className="btn--con"><div className='button-small transition continue' onClick={() => { this.applyClick(); }}><span>Apply</span></div></div>
                                 {applyCoupon && <p>Your Coupon Code is Applied</p>}
                              </div> */}
                             
                              <div className="priceDetails">
                                  <div className="price-con">
                                    <div className="price-con-left">
                                    <label>Sub Total</label>
                                    {discountPer>0 &&<div className="price-discount">{this.displayPirce(subTotal)} - {discountPer}{discountType=='percent'?'% OFF':' AED'} </div>}
                                    {couponPerDiscount>0 &&<div className="price-discount">{this.displayPirce(discountPrice>0?discountPrice:subTotal)} - {couponPerDiscount}{couponType=='percent'?'% OFF':''} </div>}
                                    </div>
                                    <div className="price-con-right">
                                      {couponDiscount > 0 && (discountPrice>0 || discountPrice<=0) && this.displayPirce(couponDiscount)}
                                      {discountPer>0 && (couponDiscount<=0||couponDiscount==undefined ) && this.displayPirce(discountPrice)}
                                      {discountPer<=0 && (couponPerDiscount<=0||couponPerDiscount==undefined) && this.displayPirce(subTotal)}
                                      </div>
                                  </div>
                                </div>
                                <div className="cutlery-con">
                                  <RadioInputNew name='cutlery' label={'Cutlery'} datas={cutleryDatas} value={cutlery} onChange={this.onChange} />
                                </div>
                                <div className="bag-con">
                                    <RadioInputNew name='bag_price' label={''} datas={bagPriceOption} isHorizontal={true} value={bag_price} onChange={this.onChange} />
                                </div>
                                <div className="totalPrice">
                                  <div class="topPriceSec">
                                    <div className="totalPriceLeft">  
                                      <strong>Total Payable</strong>
                                      <p class="hidden-mobile">Price inclusive of delivery charges  taxes</p>
                                    </div>
                                    <div className="totalPriceRight">
                                      {this.displayPirce(totalPrice)}
                                    </div>
                                  </div>                                 
                                  <p class="visible-mobile">Price inclusive of delivery charges  taxes</p>
                                </div>
                                <div className="payment-method">
                                   <RadioInputNew name='paymentMethod' label={'Payment Method'} datas={paymentOption} isHorizontal={true} value={paymentMethod} onChange={this.onChange} />
                                </div>
                                </div>
                                <div className="btn-con"><div className={`button-small transition continue`}  onClick={() => { this.savePlan(checkoutId); }}><span>Proceed to Pay</span> <strong>{this.displayPirce(totalPrice)}</strong>
                                <span className="icon"><svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 26H44.586L38.293 32.293L39.707 33.707L48.414 25L39.707 16.293L38.293 17.707L44.586 24H1V26Z" fill="white"/></svg></span></div></div>
                            </div>
                           
                       </div>
                       </div>
                      
                    </div>
                </div>
                </div>
          </div>
    </Fragment>;
    }
}

CheckoutSummary.propTypes = {
    checkoutPlanParams: PropTypes.object.isRequired,
    checkoutMealPlan: PropTypes.object.isRequired,
    setCheckoutMealPlan: PropTypes.func.isRequired,
    setCheckoutPlanParams: PropTypes.func.isRequired,
    dataArray: PropTypes.object.isRequired
};
  
const mapStateToProps = state => ({
    checkoutPlanParams: state.checkoutPlanParams,
    dataArray: state.dataArray,
    user:state.user,
    checkoutMealPlan: state.checkoutMealPlan,
    customPlans: state.customPlans
});

const bindAction = dispatch => ({
    setModal: obj => dispatch(setModal(obj)),
    setCheckoutMealPlan: plan => dispatch(setCheckoutMealPlan(plan)),
    setCheckoutPlanParams: obj => dispatch(setCheckoutPlanParams(obj)),
    updateCheckoutPlanParams: obj => dispatch(updateCheckoutPlanParams(obj)),
    spin: () => dispatch(spin()),
    stop: () => dispatch(stop()),
    updateCheckoutMealPlan: (date,obj) => dispatch(updateCheckoutMealPlan(date,obj)),
    clearModal: obj => dispatch(clearModal(obj))
});
   
export default socketConnect(connect(mapStateToProps, bindAction)(CheckoutSummary));